import { NgModule } from '@angular/core';
import { TRAINER_ENTITY_SERVICE_TOKEN, CUSTOMER_ENTITY_SERVICE_TOKEN, COURSE_ENTITY_SERVICE_TOKEN, REQUISITION_ENTITY_SERVICE_TOKEN, CLASSES_ENTITY_SERVICE_TOKEN } from '../injection-tokens/entity-service-tokens';
import { CourseEntityService } from '../services/entity-services/course-entity.service';
import { CustomerEntityService } from '../services/entity-services/customer-entity.service';
import { TrainerEntityService } from '../services/entity-services/trainer-entity.service';
import { InMemoryRequisitionEntityService } from '../services/entity-services/in-memory-requisition-entity.service';
import { ClassEntityService } from '../services/entity-services/classes-entity.service';
import { RequisitionEntityService } from '../services/entity-services/requisition-entity.service';

@NgModule({
  providers: [
    {
      provide: TRAINER_ENTITY_SERVICE_TOKEN,
      useClass: TrainerEntityService
    },
    {
      provide: CUSTOMER_ENTITY_SERVICE_TOKEN,
      useClass: CustomerEntityService
    },
    {
      provide: COURSE_ENTITY_SERVICE_TOKEN,
      useClass: CourseEntityService
    },
    {
      provide: REQUISITION_ENTITY_SERVICE_TOKEN,
      useClass: RequisitionEntityService
    },
    {
      provide: CLASSES_ENTITY_SERVICE_TOKEN,
      useClass: ClassEntityService
    },
    // You can also provide the concrete classes for direct injection
    TrainerEntityService,
    CustomerEntityService,
    CourseEntityService
  ]
})
export class EntityServicesModule { }
